import "./polyfills";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "moment/locale/bs";
import Application from "./Application";
import "./core/ui/assets/less/Application.less";
import bsLocale from "./locale/ba.json";
import hrLocale from "./locale/hr.json";
import srLatLocale from "./locale/sr_lat.json";
import srCyrLocale from "./locale/sr_cyr.json";
const rootElement = document.getElementById("app");

export function run(appName, context = "/") {
  if (rootElement) {
    const app = new Application(appName, context, rootElement);
    app.addLocale("2", bsLocale);
    app.addLocale("3", hrLocale);
    app.addLocale("4", srLatLocale);
    app.addLocale("5", srCyrLocale);
    return app.start();
  }
}
if (typeof import.meta.env.VITE_APPLICATION_NAME === "string") {
  run(import.meta.env.VITE_APPLICATION_NAME);
} else {
  throw new Error("You must define an application!");
}
